export const EMPTY_GRID_CLASS: string = 'tp-empty-grid';
